import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'eventHeight',
  standalone: false,
})
export class EventHeightPipe implements PipeTransform {
  transform(
    layoutHeight: number,
    oneHourHeight: number,
    paddingPx: number,
    timeScale: number,
  ): number {
    return (Math.max(layoutHeight, 0.25) * oneHourHeight) / timeScale - paddingPx;
  }
}
